import { render } from "./DownloadView.vue?vue&type=template&id=70db69cf&scoped=true"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"

import "./DownloadView.vue?vue&type=style&index=0&id=70db69cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70db69cf"]])

export default __exports__